import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F2F4F7",
    color: "#667085",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));







export default function ArchivedBusinessInfomation({ value }) {
  function formatDateAndTime(dateTime) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
    const formattedDate = new Date(dateTime).toLocaleString(undefined, options);
    return formattedDate?.replace(/(\d+:\d+:\d+) ([APap][Mm])/, '$1 $2').toUpperCase();
  }
  return (
    <>

      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%', mb: 2 }}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell style={{ width: '10%' }}>Version</StyledTableCell>
                <StyledTableCell style={{ width: '10%' }}>Changed By</StyledTableCell>
                <StyledTableCell style={{ width: '10%' }}>Timestamp</StyledTableCell>
              </TableRow>
            </TableHead>
          </Table>

          {value
            ?.sort((a, b) => new Date(b.changedDateTime) - new Date(a.changedDateTime)) // Sort by newest changedDateTime
            ?.map((vendor, index) => (
              <Accordion key={index}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${index}-content`} id={`panel${index}-header`}>
                  <Typography sx={{ width: '30%' }}>{vendor?.versionNo}</Typography>
                  <Typography sx={{ width: '30%' }}>{vendor?.changedBy}</Typography>
                  <Typography sx={{ width: '30%' }}>{formatDateAndTime(vendor?.changedDateTime)}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}> Legal Name Of Business: </p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.legalNameOfBusiness}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}> Tax ID: </p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.taxId}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}> Company Principal Officer Name: </p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.principalCompanyOfficerName}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Country:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.country}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>State:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.state}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>City:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.city}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Zip/Postal Code</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.zip}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Address 1:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.address1}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Address 2:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.address2}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Address 3:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.address3}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Telephone Number:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.phoneNumber}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Phone Number Extension:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.extNumber}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Fax Number:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.faxNumber}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Website URL:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.websiteUrl}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Federal ID Number:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.federalIdNumber}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Representative Name:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.orgRepresentativeName}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>Representative Email:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.orgRepresentativeEmail}</b></Grid>
                  </Grid>
                  <hr />
                  <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    <Grid item xs={12} sm={3} md={3}>
                      <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>InfusionSoft ContactID:</p>
                    </Grid>
                    <Grid item xs={9} sm={9} md={9}><b>{vendor?.orgInfusionSoftContactId}</b></Grid>
                  </Grid>
                </AccordionDetails>

              </Accordion>
            ))}








        </Paper>
      </Box>
    </>
  )
}
